export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/VE-ea7c6d4e1acc7d3812cd0b3c49d913ad.png";